module.exports = vendor_d5d4e42a5b8d705f152b;